export const SERVICE_ACCOUNT_SUFFIX = '@services-grin.com'
